module.exports = __webpack_public_path__ + "static/media/help-rule-3.2913366d.gif";